import { render, staticRenderFns } from "./Doctorslist.vue?vue&type=template&id=68b6c0c0&"
import script from "./Doctorslist.vue?vue&type=script&lang=ts&"
export * from "./Doctorslist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports